export default {
    CORRELATION_ID: "x-correlationid",
    MAX_AGE: "max-age",
};
